import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/order-form/card_5brand.svg'


const _withScopeId = n => (_pushScopeId("data-v-93e20e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "お支払い", -1))
const _hoisted_2 = { class: "block payment-method-select" }
const _hoisted_3 = { class: "method-list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "supported-cards",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("dl", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getMethodClass(_ctx.selectedPayMethod, '3'))
        }, [
          _createElementVNode("dt", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.methodClick('3')))
          }, "クレジットカード"),
          (_ctx.selectedPayMethod == '3')
            ? (_openBlock(), _createElementBlock("dd", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ], 64))
}